<template>
      <base-modal
        :show="open"
        :title="$t('Site.ContentType.AutoImportConfig.Separator')"
        @on-confirm="save()"
        @on-cancel="hide()"
        maxWidth="30%"
        :okText="$t('Save')"
        :closeText="$t('Close')"
    >
        <v-text-field
            v-model="separator"
            v-bind:label="$t('Site.ContentType.AutoImportConfig.Separator')"
        ></v-text-field>
    </base-modal>
</template>
<script>

export default {
    name: 'ConfigAlphaNumericSeparator',
    data() {
        return {
            modal: {
                key: 'configAlphaNumericSeparator',
            },
            open: false,
            itemId: '',
            separator: ''
        };
    },
    computed: {
        modalInstance() {
            return this.$refs[this.modal.key];
        },
        modalTitle() {
            return this.modal.title;
        }
    },
    methods: {
        save() {
            this.$emit('on-separator-saved', this.separator, this.itemId);
            this.hide();
        },
        new() {
            this.$v.$reset();
            this.show();
        },
        show(itemId, separator) {
            this.open = true;
            this.itemId = itemId;
            this.separator = separator;
        },
        hide() {
            this.open = false;
        },
    },
};
</script>